import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

declare global {
  interface Window {
    WOW: any;
  }
}

interface Child {
  id: number;
  name: string;
  age: number;
  image: string;
  medical_condition?: string;
  bio?: string;
  active: boolean;
}

const Children: React.FC = () => {
  const [children, setChildren] = useState<Child[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Fetch children from API
    fetch('http://localhost:5000/api/children?active=true')
      .then(res => res.json())
      .then(data => {
        console.log('Children data received:', data);
        data.forEach((child: Child) => {
          console.log(`Child ${child.name} image path:`, child.image);
        });
        setChildren(data);
        setLoading(false);
      })
      .catch(error => {
        console.error('Error fetching children:', error);
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    // Initialize data-background attributes
    const elements = document.querySelectorAll('[data-background]');
    elements.forEach((element) => {
      const bg = element.getAttribute('data-background');
      if (bg) {
        (element as HTMLElement).style.backgroundImage = `url(${bg})`;
      }
    });

    // Initialize WOW.js for scroll animations
    if (window.WOW) {
      const wow = new window.WOW({
        boxClass: 'wow',
        animateClass: 'animated',
        offset: 0,
        mobile: true,
        live: true
      });
      wow.init();
    }
  }, [children]);

  return (
    <>
      {/* Page banner area start here */}
      <section className="banner__inner-page bg-image pt-160 pb-160"
        data-background="/assets/images/banner/banner-inner-page.jpg">
        <div className="container">
          <h2 className="wow fadeInUp" data-wow-delay="00ms" data-wow-duration="1500ms">Our Children</h2>
          <div className="breadcrumb-list wow fadeInUp" data-wow-delay="200ms" data-wow-duration="1500ms">
            <Link to="/">Home</Link>
            <span><i className="fa-regular fa-angles-right mx-2"></i></span>
            <Link to="/about">About Us</Link>
            <span><i className="fa-regular fa-angles-right mx-2"></i>Our Children</span>
          </div>
        </div>
      </section>
      {/* Page banner area end here */}

      {loading ? (
        <div className="text-center py-5">
          <p>Loading children...</p>
        </div>
      ) : (
        <>
          {/* Children area start here */}
          <section className="team-area pt-120 pb-120">
            <div className="container">
              <div className="row g-4">
                {children.map((child, index) => (
                  <div key={child.id} className="col-lg-4 col-sm-6 wow fadeInUp" data-wow-delay={`${index * 200}ms`} data-wow-duration="1500ms">
                    <div className="team__item image">
                      <img 
                        src={child.image || '/assets/images/children/child1.jpg'} 
                        alt={child.name}
                        style={{ width: '100%', height: '451px', objectFit: 'cover' }}
                        onError={(e) => {
                          console.error('Failed to load image:', child.image);
                          e.currentTarget.src = '/assets/images/children/child1.jpg';
                        }}
                      />
                      <div className="team__content">
                        <div className="content">
                          <h4>
                            <Link to={`/children/${child.id}`} className="primary-hover">
                              {child.name}
                            </Link>
                          </h4>
                          <span>Age: {child.age} years {child.medical_condition && `• ${child.medical_condition}`}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>
          {/* Children area end here */}
        </>
      )}
    </>
  );
};

export default Children;
